import "./style.scss";

export default function Footer() {
  return <div className="bg-footer flex-auto" />;
}
